import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";
import { errorToastMessage, toastMessage } from "../../utils/toast";
import http from "../../utils/http";

type Props = {
  show: boolean;
  onClose: () => void;
  slotData?: any;
  slotIds?: string[];
  roomId: string;
  refresh: () => void;
};

const DeleteSlotModal = ({
  show,
  onClose,
  slotData,
  slotIds,
  roomId,
  refresh,
}: Props) => {
  const [loading, setLoading] = useState(false);
  const handleDelete = async () => {
    try {
      setLoading(true);

      if (slotIds && slotIds.length > 0) {
        const res = await http.post(
          `/admin/registry/appointment-rooms/${roomId}/slots/bulk-delete`,
          {
            slotIds,
          }
        );
        toastMessage("success", res.data.message);
      } else if (slotData) {
        // Single delete
        const res = await http.delete(
          `/admin/registry/appointment-rooms/${roomId}/slots/${slotData.id}`
        );
        toastMessage("success", res.data.message);
      }

      refresh();
      onClose();
    } catch (err) {
      errorToastMessage(err as Error);
    } finally {
      setLoading(false);
    }
  };

  const getDialogContent = () => {
    if (slotIds && slotIds.length > 0) {
      return `Are you sure you want to delete ${slotIds.length} selected slot${
        slotIds.length > 1 ? "s" : ""
      }? This action cannot be undone.`;
    }
    return `Are you sure you want to delete this Slot from ${slotData?.date} ${slotData?.time}?`;
  };

  return (
    <Dialog open={show} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">
        {slotIds && slotIds.length > 0 ? "Delete Slots" : "Delete Slot"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {getDialogContent()}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <>
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button
              color="error"
              variant="outlined"
              onClick={handleDelete}
              autoFocus
            >
              Delete
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSlotModal;
